<template>
	<nut-navbar
		class="navbar"
		title="用户信息"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<nut-icon
				@click="handleRightClick(USER_INFO)"
				class-prefix="icon"
				font-class-name="iconfont"
				name="question-circle"
			></nut-icon>
		</template>
	</nut-navbar>
	<nut-cell-group class="cell-group">
		<nut-cell
			title="我的昵称"
			:desc="userInfo.name"
			@click="handleOpenEditModal('nickname')"
		>
			<template v-slot:link>
				<nut-icon
					name="right"
					class-prefix="icon"
					font-class-name="iconfont"
				>
				</nut-icon>
			</template>
		</nut-cell>
		<nut-cell title="手机号码" :desc="userInfo.phone"></nut-cell>
		<nut-cell
			title="店铺名"
			:desc="userInfo.shop"
			@click="handleOpenEditModal('shop')"
		>
			<template v-slot:link>
				<nut-icon
					name="right"
					class-prefix="icon"
					font-class-name="iconfont"
				>
				</nut-icon>
			</template>
		</nut-cell>
		<nut-cell
			title="店铺电话"
			:desc="userInfo.telephone"
			@click="handleOpenEditModal('tel')"
		>
			<template v-slot:link>
				<nut-icon
					name="right"
					class-prefix="icon"
					font-class-name="iconfont"
				>
				</nut-icon>
			</template>
		</nut-cell>
		<nut-cell
			title="店铺地址"
			:desc="userInfo.address"
			@click="handleOpenEditModal('address')"
		>
			<template v-slot:link>
				<nut-icon
					name="right"
					class-prefix="icon"
					font-class-name="iconfont"
				>
				</nut-icon>
			</template>
		</nut-cell>
	</nut-cell-group>
	<edit-info-modal
		v-if="visible"
		v-model="visible"
		:userInfo="userInfo"
		:type="currentType"
		@refresh="getUserInfo"
	/>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import EditInfoModal from './components/editInfoModal';
import useNavigate from '@/hooks/useNavigate';
import useDialog from '@/hooks/useDialog';
import { USER_INFO } from '@/constants/tiptype';

export default {
	name: 'UserInfo',
	components: {
		EditInfoModal,
	},
	setup() {
		const store = useStore();
		const visible = ref(false);
		const currentType = ref('nickname');
		const userInfo = ref({});
		const { goBack } = useNavigate();
		const { handleOpenDialog } = useDialog();

		const handleRightClick = (type) => {
			handleOpenDialog(type);
		};

		const handleOpenEditModal = (type) => {
			visible.value = true;
			currentType.value = type;
		};

		const getUserInfo = async () => {
			const info = await store.dispatch('user/getUserInfo');
			if (info) {
				userInfo.value = info;
			}
		};

		onMounted(() => {
			getUserInfo();
		});

		return {
			userInfo,
			visible,
			currentType,
			USER_INFO,
			goBack,
			handleRightClick,
			handleOpenEditModal,
			getUserInfo,
		};
	},
};
</script>

<style lang="scss" scoped>
.cell-group {
	:deep(.nut-cell:last-child::after) {
		border-bottom: 2px solid #f5f6f7 !important;
	}
	:deep(.nut-cell__value) {
		font-size: $small-font-size;
	}
}
</style>
